import tinycolor from 'tinycolor2';
import isNaN from 'lodash/isNaN';

const _selectedBorder = '1px solid #00729A';
const _defaultBorder = '1px solid #ebebeb';

class HeatmapHelperService {
  scrollType = {
    vertical: 1,
    horizontal: 2,
  };

  getColorBypX(val) {
    if (!val) {
      return null;
    }

    if (this.getTinycolorByVal(val).getLuminance() <= 0.5) {
      return '#FFFFFF';
    }

    return '#000000';
  }

  getBgColorBypX(val) {
    if (this.isNoData(val)) {
      return '#FFFFFF';
    }
    if (this.isNotExpressed(val)) {
      return '#dcdcdc';
    }
    return this.getTinycolorByVal(val).toHexString();
  }

  getTinycolorByVal = (val) => {
    return tinycolor(`hsl(${((15 - val / 10) / 15) * 233}, 100%, 50%)`);
  };

  getVisibleValueBypX(val) {
    if (this.isNoData(val) || this.isNotExpressed(val)) {
      return null;
    }

    return val / 10;
  }

  isNoData = (val) => {
    return val === 0 || val === '0' || !val || isNaN(val);
  };

  isNotExpressed = (val) => {
    return val === 151 || val === '151';
  };

  getCellBorder = (selectedArrays, index, isPrevious) => {
    const _index = isPrevious ? index - 1 : index + 1;
    return selectedArrays.indexOf(_index) === -1 ? _selectedBorder : _defaultBorder;
  };

  isIE = () => {
    return !!window.MSInputMethodContext && !!document.documentMode;
  };
}

export default new HeatmapHelperService();
